export * from './bericht-detail.component';
export * from './bericht-detail.component.module';